import { Component, Input, OnInit } from '@angular/core';
import { AppDirection } from 'src/app/core/types/app-direction.type';

import { AppExpandTextClickShowEvent } from 'src/app/core/types/app-expand-text-click-show-event.type';
import { AppPlacement } from 'src/app/core/types/app-placement.type';

@Component({
    selector: 'app-expand-text-click',
    templateUrl: './expand-text-click.component.html',
    standalone: false
})
export class ExpandTextClickComponent implements OnInit {

  @Input() title: any;
  @Input() smallText: any;
  @Input() customClass: string;
  @Input() placement: AppPlacement = "left";
  @Input() direction: AppDirection = "rtl";
  @Input() showEvent: AppExpandTextClickShowEvent = "click";

  fontClass: any;

  constructor() { }

  ngOnInit() {
    this.fontClass = "fas fa-chevron-" + this.placement;
  }

  isShowClickToShowMessage() {
    return this.smallText !== '-' && this.smallText !== '_' && this.smallText !== undefined && this.smallText !== null;
  }
}
